import { useDispatch } from 'react-redux';
import noop from 'utils/noop';
import { BUTTON_VARIANTS } from 'ui/button';
import { ConfirmModal } from 'ui/modal';
import { enableDeepLinkPathRequest } from '../actions';
import { AppSiteAssociations } from '../types';

export const TEXT = {
  cancelCTA: 'Cancel',
  enableCTA: 'Enable',
  enableTitle: 'Enable destination domain',
  enableText: 'Are you sure you want to enable the destination domain path?',
  disableCTA: 'Disable',
  disableTitle: 'Disable destination domain',
  disableText: 'Are you sure you want to disable the destination domain path?',
  legacyDeepLinkDisableWarning: 'Enabling it will disable the currently enabled legacy deep link.',
  legacyDeepLinkEnableWarning:
    'Enabling it will disable any other enabled deep links for this tracking domain.',
};

type Props = {
  hasActiveLegacyDomain: boolean;
  onClose: () => void;
  selectedAppSiteAssociation: AppSiteAssociations;
};

export const EnablePathModal = ({
  hasActiveLegacyDomain = false,
  onClose = noop,
  selectedAppSiteAssociation,
}: Props) => {
  const dispatch = useDispatch();

  const isEnabled = selectedAppSiteAssociation.enabledForProject;
  const isLegacyPath = !selectedAppSiteAssociation.appDomain;
  const displayLegacyDisableWarning = !isLegacyPath && !isEnabled && hasActiveLegacyDomain;
  const displayLegacyEnableWarning = isLegacyPath && !isEnabled;

  const enablePath = () => {
    dispatch(
      enableDeepLinkPathRequest(
        {
          ...selectedAppSiteAssociation,
          enabledForProject: !selectedAppSiteAssociation.enabledForProject,
        },
        hasActiveLegacyDomain,
      ),
    );
    onClose();
  };

  return (
    <ConfirmModal
      onClose={onClose}
      cancelLabel={TEXT.cancelCTA}
      id="enable-path-modal"
      data-test="enable-path-modal"
      isModalOpen
      onConfirm={enablePath}
      confirmButtonVariant={isEnabled ? BUTTON_VARIANTS.DESTRUCTIVE : BUTTON_VARIANTS.PRIMARY}
      confirmButtonContent={isEnabled ? TEXT.disableCTA : TEXT.enableCTA}
      headerContent={isEnabled ? TEXT.disableTitle : TEXT.enableTitle}
      bodyContent={
        <>
          <p>{isEnabled ? TEXT.disableText : TEXT.enableText}</p>
          {displayLegacyDisableWarning && <p>{TEXT.legacyDeepLinkDisableWarning}</p>}
          {displayLegacyEnableWarning && <p>{TEXT.legacyDeepLinkEnableWarning}</p>}
        </>
      }
    />
  );
};
